import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  apiUrl: string = environment.url.API_URL
  baseUrl: string = environment.url.CHAT_BOT
  constructor(private toastr: ToastrService, private http: HttpClient) { }

  openSnackBar(message, type) {

    if (type === 'Success') {
      this.toastr.success(message)
    }
    if (type === 'Error') {
      this.toastr.error(message)
    }
  }

  getFleetList() {
    let params = new HttpParams().set('status', 'ACTIVE');
    return this.http.get(this.apiUrl + 'fleets', { params });
  }

  getToolList() {
    return this.http.get(this.baseUrl + 'chatbot/utility/tools');
  }

  getConsumerList() {
    return this.http.get(this.apiUrl + 'consumers/fleetready-copilot');
  }

  getHistory() {
    return this.http.get(this.baseUrl + 'chatbot/utility/chat/threads')
  }
  getHistoryById(id: string) {
    return this.http.get(this.baseUrl + 'chatbot/utility/chat/threads/' + id + '/history')
  }
}
